var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgHomeTab = function SvgHomeTab(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 6.19L17.5 10.69V18.5H15.5V12.5H9.5V18.5H7.5V10.69L12.5 6.19ZM12.5 3.5L2.5 12.5H5.5V20.5H11.5V14.5H13.5V20.5H19.5V12.5H22.5L12.5 3.5Z",
    fill: "currentColor"
  })));
};
var Memo = /*#__PURE__*/memo(SvgHomeTab);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "_/_/packages/moonlight/lib/assets/icons/home-tab.2ec87e88e20b751f01246656d14512bc.svg";